import { formatEtDate } from '@/lib/cashFlow';

/**
 * The app's single date *display* primitive: renders an ISO `YYYY-MM-DD` as the
 * Estonian "DD.MM.YYYY" inside a semantic `<time>`, with a fallback for null. ISO
 * stays in the data layer; the UI never shows a raw ISO string.
 */
export function DateText({
  iso,
  fallback = '—',
  className,
}: {
  iso: string | null | undefined;
  fallback?: string;
  className?: string;
}) {
  if (!iso) return <span className={className}>{fallback}</span>;
  return (
    <time dateTime={iso} className={className}>
      {formatEtDate(iso)}
    </time>
  );
}
